import { axios } from '@/utils/request'

const baseURL = '/jpaas-jiop-web-server'
function getCookieData (cookieName) {
  try {
    var name = cookieName + '='
    var cookieMsg = document.cookie.replace(/%/g, '%25')
    var decodedCookie = decodeURIComponent(cookieMsg)
    var cookieArray = decodedCookie.split(';')
    for (var i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i]
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1)
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length)
      }
    }
    return ''
  } catch (err) {
    console.log(err, 'cookieErr')
  }
}
// 使用示例
const token = getCookieData('accessToken') || ''
const api = {
  // 小铃铛数字
  unReadNum: '/jpaas-jms-web-server/interface/unReadNum', // 查询事项表单
  // http://192.168.10.51:30000/jpaas-jms-web-server/interface/unReadNum
  findMaterialByIids: baseURL + '/interface/information/findMaterialByIids', // 查询事项表单
  // 判断是否登录
  isLogin: baseURL + '/interface/buttjoint/jisbuttsuccess',
  // 获取登录用户信息
  getCurrentJis: baseURL + '/interface/buttjoint/getCurrentJis',
  // 获取登录页面url
  getLoginUrl: baseURL + '/interface/buttjoint/jisurl',
  // 获取事项步骤配置
  findReportConfigByIid: baseURL + '/interface/reportconfig/findReportConfigByIid',
  // 查询办件获取短信验证码
  getVerifyCode: baseURL + '/interface/verify/getVerifyCode',
  // 退出登录
  outLogin: baseURL + '/interface/buttjoint/loginOut',
  matterFilterList: baseURL + '/front/matter/matter-filter-list', // 单事项列表页轮播数据
  districtList: baseURL + '/front/matter/district-list', // 区划数据查询
  groupList: baseURL + '/front/matter/group-list', // 根据地区查询区
  // 根据情形选择的材料id获取材料上传页的数据
  getMaterialInfo: baseURL + '/interface/material/findMaterialByIids',
  // 材料上传接口
  uploadFile: baseURL + '/interface/handling/uploadFile',
  // 获取草稿详情
  getDraftDetail: baseURL + '/interface/draft/showDetail',
  // 提交草稿
  materialSubmit: baseURL + '/interface/draft/formSubmit',
  // 查询是否有草稿接口
  queryDraft: baseURL + '/interface/draft/queryDraft',
  // 提交办件
  submitHandle: baseURL + '/interface/handling/formSubmit',
  findHandlingDetail: baseURL + '/interface/handling/findHandlingDetail', // 办件详情
  findHandlingByApplyNumber: baseURL + '/interface/verify/findHandlingByApplyNumber',

  findItemBeanSimple: baseURL + '/front/matter/find-item-bean-simple', // 查询办事指南信息简洁版
  findOption: baseURL + '/interface/handling/findDimensionValue', // 查询维度.
  // 查询表单提交加密公钥
  getPublicKey: baseURL + '/interface/handling/getPublicKey',
  // 加载主题分类
  findOneThingTheme: baseURL + '/front/matter/findOneThingTheme',
  // 政务服务地图接口
  getMap: '/jpaas-jmap-web-server/interface/search/find-placeinfo-data',
  // 一件事主题分类接口
  findOneThingMatter: baseURL + '/front/matter/findOneThingMatter',
  // 查询元数据
  findMetaData: baseURL + '/front/meta/findMetaData',
  findByDistrictCode: baseURL + '/interface/label/findByDistrictCode',
  findChildList: baseURL + '/interface/label/find-child-list',
  matterList: baseURL + '/interface/label/find-relate-item',
  findMightrList: baseURL + '/front/matter/find-mightr-list',
  // 查询事项服务接口
  findServiceList: baseURL + '/front/matter/new-find-mightr-list',
  // 查询校验信息
  findCheckInfo: baseURL + '/interface/verify/findCheckInfo',
  // 主题地址接口
  itemThemeList: baseURL + '/front/matter/new-item-theme-list',
  // 获取办件地址
  getUrl: baseURL + '/interface/config/get-url',
  // 获取办件进度
  getBjjd: baseURL + '/interface/verify/findHandlingProcess',
  findSituationByIid: baseURL + '/interface/situation/findSituationByIid',
  // 根据选项id查询上传材料id
  findoptionvalfileidByIid: baseURL + '/interface/situation/findoptionvalfileidByIid',
  // 查询机器人配置
  getAssistant: baseURL + '/interface/config/get-assistant',
  findProgressResult: baseURL + '/interface/agent/handling/findProgressResult',
  findFormDetail: baseURL + '/interface/agent/form/findFormDetail',
  finditemSimple: baseURL + '/interface/agent/find-item-bean-simple',
  findonethingSimple: baseURL + '/interface/agent/oneThingHandLing',
  currentQuestion: baseURL + '/interface/agent/handling/currentQuestion',
  nextQuestion: baseURL + '/interface/agent/handling/nextQuestion',
  finishQuestion: baseURL + '/interface/agent/handling/finishQuestion',
  findBaseTipMessage: baseURL + '/interface/agent/handling/findBaseTipMessage',
  // 材料智能预填：异步提交 / 进度轮询 / 取消
  materialPrefill: baseURL + '/interface/handling/material/prefill',
  prefillProgress: baseURL + '/interface/handling/material/prefill/progress',
  prefillCancel: baseURL + '/interface/handling/material/prefill/cancel'
}

export const jiopWebAPI = {
  nextQuestion (parameter) {
    return axios({
      url: api.nextQuestion,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken,
        'Content-Type': 'application/json'
      }
    })
  },
  finishQuestion (parameter) {
    return axios({
      url: api.finishQuestion,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken,
        'Content-Type': 'application/json'
      }
    })
  },
  currentQuestion (parameter) {
    return axios({
      url: api.currentQuestion,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken,
        'Content-Type': 'application/json'
      }
    })
  },
  findoptionvalfileidByIid (parameter) {
    return axios({
      url: api.findoptionvalfileidByIid,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findBaseTipMessage (parameter) {
    return axios({
      url: api.findBaseTipMessage,
      method: 'get',
      params: parameter
    })
  },
  getBjjd (parameter) {
    return axios({
      url: api.getBjjd,
      method: 'get',
      params: parameter
    })
  },
  findFormDetail (parameter) {
    return axios({
      url: api.findFormDetail,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || getCookieData('access-token') || ''
      }
    })
  },
  findProgressResult (parameter) {
    return axios({
      url: api.findProgressResult,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || getCookieData('access-token') || ''
      }
    })
  },
  // 材料智能预填：异步提交，返回 taskId
  materialPrefill (parameter) {
    const authToken = getCookieData('accessToken') || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || getCookieData('access-token') || ''
    return axios({
      url: api.materialPrefill,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || getCookieData('access-token') || '',
        'Content-Type': 'application/json'
      }
    })
  },
  // 材料智能预填：进度轮询
  getPrefillProgress (parameter) {
    const authToken = getCookieData('accessToken') || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || ''
    return axios({
      url: api.prefillProgress,
      method: 'get',
      params: parameter,
      headers: {
        'accessToken': authToken,
        'appType': sessionStorage.getItem('appType') || 'web',
        'userType': sessionStorage.getItem('userType') || 1
      }
    })
  },
  // 材料智能预填：取消任务
  cancelPrefill (parameter) {
    const authToken = getCookieData('accessToken') || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || ''
    return axios({
      url: api.prefillCancel,
      method: 'post',
      params: parameter,
      headers: {
        'accessToken': authToken,
        'Content-Type': 'application/json',
        'appType': sessionStorage.getItem('appType') || 'web',
        'userType': sessionStorage.getItem('userType') || 1
      }
    })
  },
  getAssistant (parameter) {
    return axios({
      url: api.getAssistant,
      method: 'get',
      params: parameter
    })
  },
  getUrl (parameter) {
    return axios({
      url: api.getUrl,
      method: 'get',
      params: parameter
    })
  },
  itemThemeList (parameter) {
    return axios({
      url: api.itemThemeList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  finditemSimple (parameter) {
    return axios({
      url: api.finditemSimple,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findonethingSimple (parameter) {
    return axios({
      url: api.findonethingSimple,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0',
        'Content-Type': 'application/json'
      }
    })
  },
  findCheckInfo (parameter) {
    return axios({
      url: api.findCheckInfo,
      method: 'post',
      data: parameter
    })
  },
  unReadNum (parameter) {
    return axios({
      url: api.unReadNum,
      method: 'post',
      data: parameter
    })
  },
  findMightrList (parameter) {
    return axios({
      url: api.findMightrList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  matterList (parameter) {
    return axios({
      url: api.matterList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findMetaData (parameter) {
    return axios({
      url: api.findMetaData,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findChildList (parameter) {
    return axios({
      url: api.findChildList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findByDistrictCode (parameter) {
    return axios({
      url: api.findByDistrictCode,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findOneThingMatter (parameter) {
    return axios({
      url: api.findOneThingMatter,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findOneThingTheme (parameter) {
    return axios({
      url: api.findOneThingTheme,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  getCurrentJis (parameter) {
    return axios({
      url: api.getCurrentJis,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  getPublicKey (parameter) {
    return axios({
      url: api.getPublicKey,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findOption (parameter) {
    return axios({
      url: api.findOption,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findHandlingByApplyNumber (parameter) {
    return axios({
      url: api.findHandlingByApplyNumber,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findItemBeanSimple (parameter) {
    return axios({
      url: api.findItemBeanSimple,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  queryDraft (parameter) {
    return axios({
      url: api.queryDraft,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findHandlingDetail (parameter) {
    return axios({
      url: api.findHandlingDetail,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findMaterialByIids (parameter) {
    return axios({
      url: api.findMaterialByIids,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  isLogin (parameter) {
    return axios({
      url: api.isLogin,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  getLoginUrl (parameter) {
    return axios({
      url: api.getLoginUrl,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findReportConfigByIid (parameter) {
    return axios({
      url: api.findReportConfigByIid,
      method: 'post',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  getVerifyCode (parameter) {
    return axios({
      url: api.getVerifyCode,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  outLogin (parameter) {
    return axios({
      url: api.outLogin,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  groupList (parameter) {
    return axios({
      url: api.groupList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  districtList (parameter) {
    return axios({
      url: api.districtList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  matterFilterList (parameter) {
    return axios({
      url: api.matterFilterList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  getMaterialInfo (parameter) {
    return axios({
      url: api.getMaterialInfo,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  uploadFile (parameter) {
    return axios({
      url: api.uploadFile,
      method: 'post',
      data: parameter,
      headers: {
        'Content-Type': 'multipart/form-data',
        'access-token': JSON.parse(sessionStorage.getItem('JiopUserInfo')).accessToken
      }
    })
  },
  getDraftDetail (parameter) {
    return axios({
      url: api.getDraftDetail,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  materialSubmit (parameter) {
    return axios({
      url: api.materialSubmit,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  submitHandle (parameter) {
    return axios({
      url: api.submitHandle,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  getMap (parameter) {
    return axios({
      url: api.getMap,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  },
  findSituationByIid (parameter) {
    return axios({
      url: api.findSituationByIid,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findServiceList (parameter) {
    return axios({
      url: api.findServiceList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken || '0'
      }
    })
  }
}
